export const productCarouselConstants = {
  GETALL_REQUEST: 'PRODUCT_CAROUSEL_GETALL_REQUEST',
  GETALL_SUCCESS: 'PRODUCT_CAROUSEL_GETALL_SUCCESS',
  GETALL_FAILURE: 'PRODUCT_CAROUSEL_GETALL_FAILURE',

  GET_REQUEST: 'PRODUCT_CAROUSEL_GET_REQUEST',
  GET_SUCCESS: 'PRODUCT_CAROUSEL_GET_SUCCESS',
  GET_FAILURE: 'PRODUCT_CAROUSEL_GET_FAILURE',

  ADD_REQUEST: 'PRODUCT_CAROUSEL_ADD_REQUEST',
  ADD_SUCCESS: 'PRODUCT_CAROUSEL_ADD_SUCCESS',
  ADD_FAILURE: 'PRODUCT_CAROUSEL_ADD_FAILURE',

  UPDATE_REQUEST: 'PRODUCT_CAROUSEL_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'PRODUCT_CAROUSEL_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'PRODUCT_CAROUSEL_UPDATE_FAILURE',
};
